<template>
  <div class="form-container">
    <div class="form-container__item">
      <RCInput
        class="create-account-inputs__input-field"
        :class="emptyFields['name'] === true ? 'missing-field' : ''"
        :label="$t('stopsInfo.createStopInfo.name')"
        :floatLabel="true"
        :type="'text'"
        :requiredField="true"
        :minlength="inputLimits.name.min"
        :maxlength="inputLimits.name.max"
        v-model="newAccountInfo.name"
      />
      <small
        id="phone-email"
        class="p-error"
      >
        {{ validationError.name }}</small>
    </div>
    <div class="form-container__item">
      <RCInput
        class="create-account-inputs__input-field"
        :class="emptyFields['street'] === true ? 'missing-field' : ''"
        :label="$t('stopsInfo.createStopInfo.street')"
        :type="'text'"
        :floatLabel="true"
        :requiredField="true"
        :minlength="inputLimits.street.min"
        :maxlength="inputLimits.street.max"
        v-model="newAccountInfo.street"
      />
       <small
        id="phone-email"
        class="p-error"
      >
        {{ validationError.street }}</small>
    </div>
    <div class="form-container__item">
      <AutoComplete
        :label="$t('stopsInfo.createStopInfo.city')"
        :suggestions="filteredCity"
        :requiredField="true"
        :missingField="emptyFields['city'] === true"
        :showPrefixIcon="false"
        @search="searchWord($event, 'city')"
        @selectOption="selectWord($event)"
        @blur="updateWord()"
        v-model="newAccountInfo.city"
      />
    </div>
    <div class="form-container__item">
      <RCInput
        class="create-account-inputs__input-field create-account-inputs__input-field--state-code"
        :class="emptyFields['state_code'] === true ? 'missing-field' : ''"
        type="text"
        :label="$t('stopsInfo.createStopInfo.stateCode')"
        :floatLabel="true"
        :disabled="true"
        v-model="newAccountInfo.state_code"
        :minlength="inputLimits.zip_code.min"
        :maxlength="inputLimits.zip_code.max"
        :key="keyState"
      />
    </div>
    <div class="form-container__item">
      <AutoComplete
        :label="$t('stopsInfo.createStopInfo.zipCode')"
        :suggestions="filteredZipCode"
        :requiredField="true"
        :missingField="emptyFields['zip_code'] === true"
        :showPrefixIcon="false"
        @search="searchWord($event, 'zipCode')"
        @selectOption="selectWord($event)"
        @blur="updateWord()"
        v-model="newAccountInfo.zip_code"
      />
    </div>
    <div class="form-container__item">
      <RCSelect
        class="create-account-inputs__input-field"
        :class="emptyFields['country_code'] === true ? 'missing-field' : ''"
        :suggestions="countryCodes"
        :floatLabel="true"
        :label="$t('stopsInfo.createStopInfo.countryCode')"
        v-model="newAccountInfo.country_code"
      />
    </div>
    <AlertStreetValidations v-if="streetHaveSymbols" class="alert-error" />
  </div>
</template>

<script>
import RestrictionsFTLAndExpedited from "@/Extend/RestrictionsFTLAndExpedited";
import AlertStreetValidations from "@/components/AlertStreetValidations.vue";
import AutoComplete from "@/components/AutoComplete.vue";
import LocationSchema from "../../../../schemas/NewLocationSchema";
import RCInput from "../../../../components/RCComponents/CustomRCInput.vue";
import RCSelect from "../../../../components/RCComponents/CustomRCSelect.vue";

export default {
  name: "CreateAccountInputs",
  props: { newAccountInfo: Object, zipcode: String },
  mixins: [RestrictionsFTLAndExpedited],
  components: {
    RCInput,
    RCSelect,
    AlertStreetValidations,
    AutoComplete,
  },
  data() {
    return {
      filteredCity: [],
      filteredZipCode: [],
      validationError: [],
      selectedLocation: {
        country_code: "US",
        city: "",
        state_code: "",
        zip_code: "",
        street: "",
        name: "",
        createLocationInBd: true,
      },
      emptyFields: {
        country_code: false,
        city: false,
        state_code: false,
        zip_code: false,
        name: false,
        street: false,
      },
      countryCodes: [
        { label: "US", value: "US" },
        { label: "CA", value: "CA" },
        { label: "MX", value: "MX" },
      ],
      keyState: 0,
      tokenInfo: null,
      streetHaveSymbols: false,
      inputLimits: {
        name: {
          min: 1,
          max: 40,
        },
        street: {
          min: 1,
          max: 40,
        },
        city: {
          min: 2,
          max: 25,
        },
        zip_code: {
          min: 5,
          max: 10,
        },
      },
    };
  },
  created() {
    this.tokenInfo = this.$store.getters["login/getTokenInfo"];
    this.selectedLocation = {
      city: this.newAccountInfo.city,
      country_code: this.newAccountInfo.country_code,
      state_code: this.newAccountInfo.state_code,
      zip_code: this.newAccountInfo.zip_code,
      name: this.newAccountInfo.name,
      street: this.newAccountInfo.street,
    };
    if (this.zipcode) {
      this.selectedLocation.zip_code = this.zipcode;
    }
  },
  watch: {
    newAccountInfo: {
      deep: true,
      handler() {
        this.selectedLocation = {
          city: this.newAccountInfo.city,
          country_code: this.newAccountInfo.country_code,
          state_code: this.newAccountInfo.state_code,
          zip_code: this.newAccountInfo.zip_code,
          name: this.newAccountInfo.name,
          street: this.newAccountInfo.street,
        };
      },
    },
    "newAccountInfo.street": {
      handler(newValue) {
        const alphanumeric = /^[a-zA-Z0-9\s/,\-.]*$/;
        if (!alphanumeric.test(newValue)) {
          this.streetHaveSymbols = true;
          this.emptyFields.street = true;
          return;
        }
        this.streetHaveSymbols = false;
        this.emptyFields.street = false;
      },
    },
    "$route.params": {
      immediate: true,
      handler() {
        if (
          this.$route.params.quoteType === "ftl" ||
          this.$route.params.quoteType === "expedited"
        ) {
          this.denyCanadaCountryInFtlAndExpeditedLoad();
        }
      },
    },
  },
  methods: {
    async searchWord(event, type) {
      if (!event.query.trim().length || event.query.length < 2) {
        switch (type) {
          case "city":
            this.filteredCity = [];
            break;
          case "zipCode":
            this.filteredZipCode = [];
            break;
          default:
            break;
        }
      } else {
        let response;
        let data = {};
        switch (type) {
          case "city":
            data = {
              params: {
                city: event.query,
              },
            };
            response = await this.$store.dispatch("load/stops/getAllLocations", data);
            this.filteredCity = [
              {
                options: response.map((item) => ({
                  ...item,
                  label: `${item.city}, ${item.state_code}, ${item.zip_code}`,
                })),
              },
            ];
            break;
          case "zipCode":
            data = {
              params: {
                zip_code: event.query,
                country_code: this.newAccountInfo.country_code,
              },
            };
            response = await this.$store.dispatch("load/stops/getAllLocations", data);
            this.filteredZipCode = [
              {
                options: response.map((item) => ({
                  ...item,
                  label: `${item.city}, ${item.state_code}, ${item.zip_code}`,
                })),
              },
            ];
            break;
          default:
            break;
        }
      }
    },
    async selectWord(location) {
      this.newAccountInfo.city = location.city;
      this.newAccountInfo.state_code = location.state_code;
      this.newAccountInfo.zip_code = location.zip_code;
      this.selectedLocation = location;
      // this.keyState += 1;
    },
    updateWord() {
      if (
        // eslint-disable-next-line operator-linebreak
        this.newAccountInfo.city !== this.selectedLocation.city ||
        // eslint-disable-next-line operator-linebreak
        this.newAccountInfo.city === "" ||
        // eslint-disable-next-line operator-linebreak
        this.newAccountInfo.zip_code !== this.selectedLocation.zip_code ||
        this.newAccountInfo.zip_code === ""
      ) {
        this.newAccountInfo.city = "";
        this.newAccountInfo.state_code = "";
        this.newAccountInfo.zip_code = "";
        this.$emit("updateNewAccountInfo", this.newAccountInfo);
        this.keyState += 1;
      }
    },
    async validateFormfields() {
      try {
        this.validationError = [];
        Object.keys(this.emptyFields).forEach((key) => {
          this.emptyFields[key] = false;
        });

        const isValid = await LocationSchema.validate(this.newAccountInfo, {
          abortEarly: false,
        });

        return isValid;
      } catch (error) {
        error.inner.forEach((element) => {
          this.emptyFields[element.path] = true;
          this.validationError[element.path] = element.message;
        });
        return false;
      }
    },
    resetEmptyFieldsValues() {
      const keys = Object.keys(this.emptyFields);
      keys.forEach((key) => {
        this.emptyFields[key] = false;
      });
    },
    handleMissingStyles(value, attribute) {
      if (value) {
        this.emptyFields[attribute] = false;
      } else {
        this.emptyFields[attribute] = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "../../../../assets/scss/components/RCComponents.scss";
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;

.form-container {
  margin-top: 15px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  &__item {
    &--phone {
      position: relative;
      display: flex;
      flex-direction: column;
      border-radius: 7px;
      border: 1px solid $color-border-container !important;
    }
  }
}

.alert-error {
  width: 95%;
  margin: auto;
}
</style>
